import React from 'react';
import { painPoints } from '../data/painPoints';
import { PRODUCT } from '../data/constants';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-149" data-mp="38xetra38ohqd">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-150" data-mp="2uyfdappvr95a">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-151" data-mp="2uxvwxdfvostd">
          ET SI CHAQUE PANNE <span className="text-tech-light" data-id="element-152" data-mp="2yxxpmx3mybwi">SE DIAGNOSTIQUAIT AVEC MÉTHODE ?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-153" data-mp="2l718c2f5th4r">
          Vous savez déjà brancher un scanner et tenir un multimètre. Le vrai défi, c’est de savoir{' '}
          <strong className="text-white" data-id="element-154" data-mp="2b83dyiv1ytdu">
            quoi vérifier en premier, dans quel ordre, et comment confirmer avant de remplacer
          </strong>{' '}
          une pièce. Au lieu de chercher dans des informations dispersées, {PRODUCT} vous donne un
          système organisé, du symptôme à la réparation validée.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-155" data-mp="3rmhlgusali5t">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border-l-4 border-alert bg-navy-deep p-3 sm:p-4" data-id="element-156" data-mp="3nm73skv513b4">
              <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-157" data-mp="5dq268j6vcb6">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-158" data-mp="emxip74f83q">{point.body}</p>
            </article>)}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-tech-light sm:text-lg" data-id="element-159" data-mp="33xq1gqouw644">
          Observer. Lire. Mesurer. Valider.
        </p>
      </div>
    </section>;
}